export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";